<template>
	<div class="d-flex">
		<PostForm class="post-form" />
		<v-spacer />
	</div>
</template>
<script>
import PostForm from '@/components/Forms/PostForm'
export default {
	name: 'PostCreatePage',
	components: {
		PostForm,
	},
}
</script>

<style lang="scss">
.post-form {
	max-width: 854px;
}
</style>
